import { RouteRecordRaw } from 'vue-router';
import { RouteMetaType, ExtendedRouteMetaType } from '@router/routes/types';
import { ENTRY_POINTS } from '@constants/entry-points';

type TenantAdminAppRouteMetaType = RouteMetaType & {
  requiresAuth: true;
  requiresTenant: true;
  requiresTenantAdmin: true;
  requiresEnterpriseLicense: boolean;
};

const META_DEFAULT: TenantAdminAppRouteMetaType = Object.freeze({
  requiresAuth: true,
  requiresTenant: true,
  requiresTenantAdmin: true,
  requiresEnterpriseLicense: false,
  redirectOnError: ENTRY_POINTS.PATH.USER_HOME(),
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getMeta = (
  extendedMeta: ExtendedRouteMetaType<TenantAdminAppRouteMetaType> = {},
): TenantAdminAppRouteMetaType => ({ ...META_DEFAULT, ...extendedMeta });

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: 'admin',
  //   component: () => import('@views/tenant-app/XXXView.vue'),
  //   redirect: ENTRY_POINTS.PATH.TENANT_HOME(),
  //   meta: getMeta(),
  //   children: [],
  // },
];

export default routes;
